export const isBrowser = typeof window !== "undefined";

export const shouldReduceMotion = () => {
  if (!isBrowser || !window.matchMedia) return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
};

export const isFinePointer = () => {
  if (!isBrowser || !window.matchMedia) return false;
  return window.matchMedia("(hover: hover) and (pointer: fine)").matches;
};
